// extracted by mini-css-extract-plugin
module.exports = {"s1j8mz5k":"s1j8mz5k","sizeBadge":"sizeBadge","bigIcon":"bigIcon","sizeS":"sizeS","sizeM":"sizeM","sizeL":"sizeL"};